import { getIn, isObject } from 'formik'
import React from 'react'

import { isZero } from '@utils/validations'

import { DatePickerValue } from '@global/datePicker/DatePicker'

import { TypedFieldProps } from '../types/TypedFieldProps'

export const getName = <FormValues>(prefix: string, props: TypedFieldProps<FormValues>): string => {
  return `${prefix || ''}${props.name}`
}

export const getLabel = <FormValues>(props: TypedFieldProps<FormValues>): string | undefined => {
  if (!props.label) {
    return undefined
  }

  return `${props.label || ''}${props.required ? ' *' : ''}`
}

export const getPlaceholder = <FormValues>(
  props: TypedFieldProps<FormValues>
): string | undefined => {
  const base = props.placeholder ?? props.label
  if (!base) {
    return undefined
  }

  if (props.placeholder && props.label) {
    return props.placeholder
  }

  const requiredSuffix = props.required ? ' *' : ''
  return `${base}${requiredSuffix}`
}

export const getError = <FormValues>(
  errors: TypedFieldProps<FormValues>,
  error: string | undefined,
  name: string
): string => {
  const fieldError = getIn(errors, name)

  if (typeof error === 'string') return error
  if (typeof fieldError === 'string') return fieldError

  return ''
}

export const getFieldValid = <FormValues>(
  error: FormValues,
  touched: FormValues,
  value?: FormValues
): boolean => {
  return !(!!error && (touched || value) && !isObject(error) && !isObject(touched))
}

interface isFocusProps {
  value?: string | number
  label: string | undefined
  renderValue?: React.ReactNode
}

export const isFocus = ({ value, renderValue, label }: isFocusProps): boolean => {
  if (isZero(value)) {
    return true
  }
  return (!!value || !!renderValue) && !!label
}

export const getValue = <FormValues>(
  values: FormValues,
  value: string | number | DatePickerValue | undefined | null,
  name?: string
): string | number | DatePickerValue => {
  if (value !== undefined && value !== null) {
    return value
  }
  if (name) {
    return getIn(values, name) ?? ''
  }
  return ''
}
